import { GridChartView } from 'utils/components/ViewToggleButtons/ViewToggleButtons';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { WidgetConfigWithLegends } from 'widgets/WidgetLegend/WidgetConfigWithLegends.ts';

export interface VolumeCurveLegendsConfig {
    hideHistoricalVolumeExcludingAuction: boolean;
    hideTradedVolume: boolean;
    hideAuctionVolume: boolean;
    hideCumulativeTradedVolume: boolean;
    hideCumulativeHistoricalVolume: boolean;
}

export interface VolumeCurveConfiguration
    extends WidgetConfigWithHideableToolbar,
        WidgetConfigWithLegends<VolumeCurveLegendsConfig> {
    view: GridChartView;
    barSizeInMinutes: number;
}

export const initialVolumeCurveConfiguration: VolumeCurveConfiguration = {
    view: 'chart',
    barSizeInMinutes: 10,
    hideHistoricalVolumeExcludingAuction: false,
    hideTradedVolume: false,
    hideAuctionVolume: false,
    hideCumulativeTradedVolume: false,
    hideCumulativeHistoricalVolume: false,
    hideHistoricalVolumeExcludingAuctionLegend: false,
    hideTradedVolumeLegend: false,
    hideAuctionVolumeLegend: false,
    hideCumulativeTradedVolumeLegend: false,
    hideCumulativeHistoricalVolumeLegend: false,
};
